module.exports = __webpack_public_path__ + "img/Step3.99d82f99.png";